const MIN_WEAK_RUN = 6;

const PASSWORD_RULE_TIP =
    "密码8-25位，须同时包含字母和数字，且不能包含6位及以上重复或连续的字母或数字";

const hasSixOrMoreRepeatedAlphanumeric = (password) => {
    return /([A-Za-z0-9])\1{5,}/.test(password);
};

const getAlphanumericKind = (char) => {
    if (/[A-Za-z]/.test(char)) {
        return { kind: "letter", code: char.toLowerCase().charCodeAt(0) };
    }
    if (/\d/.test(char)) {
        return { kind: "digit", code: char.charCodeAt(0) };
    }
    return null;
};

const hasSixOrMoreSequentialAlphanumeric = (password) => {
    let run = 1;
    let direction = 0;
    let prev = null;

    for (let i = 0; i < password.length; i += 1) {
        const curr = getAlphanumericKind(password[i]);
        if (!curr || !prev || curr.kind !== prev.kind) {
            run = 1;
            direction = 0;
            prev = curr;
            continue;
        }

        const diff = curr.code - prev.code;
        if (diff === 1 || diff === -1) {
            if (direction === 0 || direction === diff) {
                run += 1;
                direction = diff;
            } else {
                run = 2;
                direction = diff;
            }
        } else {
            run = 1;
            direction = 0;
        }

        if (run >= MIN_WEAK_RUN) {
            return true;
        }
        prev = curr;
    }

    return false;
};

const getResetPasswordError = (password) => {
    if (!password) {
        return "请输入新密码";
    }
    if (password.length < 8 || password.length > 25) {
        return "密码长度须为8-25位字符";
    }
    const hasLetter = /[A-Za-z]/.test(password);
    const hasDigit = /\d/.test(password);
    if (!hasLetter || !hasDigit) {
        return "必须同时包含字母和数字";
    }
    if (
        hasSixOrMoreRepeatedAlphanumeric(password) ||
        hasSixOrMoreSequentialAlphanumeric(password)
    ) {
        return "不能包含6位及以上重复或连续的字母或数字";
    }
    return "";
};

const isValidResetPassword = (password) => {
    return !getResetPasswordError(password);
};

export { PASSWORD_RULE_TIP, getResetPasswordError, isValidResetPassword };
